(() => {
    const desktopNavigationOpen = document.querySelector(
        '[data-desktop-navigation-open]',
    );

    const desktopNavigationClose = document.querySelector(
        '[data-desktop-navigation-close]',
    );

    if (desktopNavigationOpen) {
        desktopNavigationOpen.addEventListener('click', () => {
            document.body.classList.add('overlay-open');
        });
    }

    if (desktopNavigationClose) {
        desktopNavigationClose.addEventListener('click', () => {
            document.body.classList.remove('overlay-open');
        });
    }
})();
